module.exports = __webpack_public_path__ + "static/img/ibank.45dd2098.svg";